import { makeField } from './tools'
import Input, { InputProps } from '../Input'
import UploadFile, { UploadFileProps } from '../UploadFile'
import DatePicker, { DatePickerProps } from '../DatePicker'
import Select, { BaseSelectProps } from '../Select'
import Switch, { SwitchProps } from '../Switch'

export const InputField = makeField<InputProps>(Input)
export const UploadfileField = makeField<UploadFileProps>(UploadFile)
export const DatePickerField = makeField<DatePickerProps>(DatePicker)
export const SelectField = makeField<BaseSelectProps>(Select)
export const SwitchField = makeField<SwitchProps>(Switch)
